class RecordGroup {
  constructor(Http, Modal, $localStorage) {
    'ngInject';
    this.$localStorage = $localStorage;
    this.Http = Http;
    this.Modal = Modal;
  }

  getList(module, params = {}) {
    return this.Http.get('/record_groups', Object.assign(params, { module: module }));
  }

  statusTypes(module) {
    return this.$localStorage[module + '_statuses'];
  }

  find(id) {
    return this.Http.get('/record_groups/' + id );
  }

  count(module) {
    return this.Http.get('/record_groups/count', { module: module } );
  }

  relatedRecordsBulkUpdate({ record_status_id, record_ids }) {
    return this.Http.put('/record_groups/'+ record_status_id +'/related_records_bulk_update', { record_ids });
  }

  returnLastStatusId(module) {
    this.$localStorage.savedRecordStatus = this.$localStorage.savedRecordStatus || {};
    return parseInt(this.$localStorage.savedRecordStatus[module]) || -1;
  }

  setLastStatusId(module, id) {
    this.$localStorage.savedRecordStatus = this.$localStorage.savedRecordStatus || {};
    this.$localStorage.savedRecordStatus[module] = id;
  }

  setLastGroupId(module, id) {
    this.$localStorage.savedRecordGroup = this.$localStorage.savedRecordGroup || {};
    this.$localStorage.savedRecordGroup[module] = id;
  }

  returnLastGroupId(module) {
    this.$localStorage.savedRecordGroup = this.$localStorage.savedRecordGroup || {};
    return parseInt(this.$localStorage.savedRecordGroup[module]);
  }

  getAssignedGroups(recordId, module) {
    return this.Http.get('/record_groups/assigned_groups', { record_id: recordId, record_module: module });
  }

  updatePosition(id, position) {
    return this.Http.put('/record_groups/' + id + '/position/', { position });
  }

  delete(id) {
    return this.Http.delete('/record_groups/' + id);
  }

  update(params) {
    return this.Http.put('/record_groups/' + params.id, params);
  }

  create(params) {
    return this.Http.post('/record_groups/', params);
  }

  assignModal(record_id, module, assignedGroups = []) {
    return this.Modal.open({
      size: 'md',
      component: 'recordGroupsModal',
      resolve: {
        recordId: () => record_id,
        module: () => module,
        assignedGroups: () => assignedGroups,
      },
    });
  }

  assign(recordId, module, groupIds) {
    return this.Http.post('/record_groups/assign_groups', { record_id: recordId, record_module: module, group_ids: groupIds });
  }

  remove(groupId, recordId, module) {
    return this.Http.delete('/record_groups/' + groupId + '/remove', { record_module: module, record_id: recordId });
  }

  getRandomEmoji() {
    const emojis = [
      '💼', // briefcase
      '🤝', // handshake
      '💰', // money bag
      '📎', // paperclip
      '🔗', // link
      '🔒', // locked
      '🔑', // key
      '📋', // clipboard
      '📝', // memo
      '💡', // lightbulb
      '💡', // bulb
      '👥', // busts in silhouette
      '🤔', // thinking face
      '💬', // speech balloon
      '💭', // thought balloon
      '💵', // dollar bill
      '💸', // money with wings
      '📤', // outbox tray
      '📥', // inbox tray
      '📧', // e-mail
      '📨', // incoming envelope
      '📩', // envelope with arrow
      '💼', // briefcase
      '🤝', // handshake
      '💰', // money bag
      '📎', // paperclip
      '🔗', // link
      '🔒', // locked
      '🔑', // key
      '📋', // clipboard
      '📝', // memo
      '💡', // lightbulb
      '👥', // busts in silhouette
      '🤔', // thinking face
      '💬', // speech balloon
      '💭', // thought balloon
      '💵', // dollar bill
      '💸', // money with wings
      '💼', // briefcase
      '🤝', // handshake
      '💰', // money bag
      '📎', // paperclip
      '🔗', // link
      '🔒', // locked
      '🔑', // key
      '📋', // clipboard
      '📝', // memo
      '💡', // lightbulb
      '👥', // busts in silhouette
      '🤔', // thinking face
      '💬', // speech balloon
      '💭', // thought balloon
      '💵', // dollar bill
      '💸', // money with wings
    ];

    const randomIndex = Math.floor(Math.random() * emojis.length);
    return emojis[randomIndex];
  }

}
export default RecordGroup;
